import React, { useState, useEffect } from "react";
import { AppBarRenderer, SideBarRenderer, MainContentRenderer } from "..";
import { DialogRenderer } from "../Components/index";
import { IDialog, IField, IOption } from "../../app/types";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setMainContentDialogPopUp } from "../MainContent/MainContentSlice";
import { GridRenderCellParams } from "@mui/x-data-grid";

/* Functional component properties */
interface Props {
  buttonClickHandler: (button: IField) => void;
  optionClickHandler: (option: IOption) => void;
  linkClickHandler: (link: GridRenderCellParams) => void;
  classes: any;
}

/* React Functional component */
export const ScreenRenderer: React.FC<Props> = ({
  /* Function arguments (Props) */
  buttonClickHandler,
  optionClickHandler,
  linkClickHandler,
  classes,
}): JSX.Element => {
  /* get state */
  const state = useAppSelector((state) => state);

  /* get dispatch */
  const dispatch = useAppDispatch();

  const [sideBarToggle, setSideBarToggle] = useState<boolean>(true);
  const [dialogOpen, setDialogOpen] = React.useState(false);

  useEffect(() => {
    if (
      Object.keys(state.mainContent.dialogPopUp).length &&
      state.mainContent.dialogPopUp.header !== ""
    )
      setDialogOpen(true);
  }, [state.mainContent.dialogPopUp]);

  const handleDrawerToggle = React.useCallback(() => {
    setSideBarToggle(!sideBarToggle);
  }, [sideBarToggle]);

  const handleDialogClose = () => {
    setDialogOpen(false);
    dispatch(setMainContentDialogPopUp({} as IDialog));
  };

  const handleDialogOpen = (data: IDialog) => {
    dispatch(setMainContentDialogPopUp(data));
    setDialogOpen(true);
  };

  return (
    <div className={classes.root}>
      <AppBarRenderer
        classes={classes}
        handleDialogOpen={handleDialogOpen}
        buttonClickHandler={buttonClickHandler}
      />
      <SideBarRenderer
        classes={classes}
        isOpen={sideBarToggle}
        handleDrawerToggle={handleDrawerToggle}
        optionClickHandler={optionClickHandler}
      />
      <MainContentRenderer
        classes={classes}
        isOpen={sideBarToggle}
        handleDrawerToggle={handleDrawerToggle}
        key={"main-content"}
        buttonClickHandler={buttonClickHandler}
        linkClickHandler={linkClickHandler}
      />
      {dialogOpen ? (
        <DialogRenderer
          isOpen={dialogOpen}
          handler={buttonClickHandler}
          handleDialogClose={handleDialogClose}
          classes={classes}
        />
      ) : (
        ""
      )}
    </div>
  );
};
